import { inputResult } from "../Submit/SaveAnswer";


export function transformLaToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    const labels = input.find(".label-item");

    // Loop through fields
    labels.each((ind, obj) => {
        // Disable Field
        const input = $(obj).find("input");
        input.prop('readonly', true);

        input.attr('value', results.answer[ind].answer);
        
    })

}